import { Component, inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-change-password',
	template: '',
	standalone: true,
})
export class ChangePasswordComponent implements OnInit {
	private readonly route = inject(ActivatedRoute);
	private readonly router = inject(Router);
	private readonly localeId = inject(LOCALE_ID);
	private readonly locale: string = this.localeId;

	ngOnInit() {
		this.route.queryParamMap.subscribe(queryParams => {
			const origin = queryParams.get('origin');

			if (origin === 'identity') {
				const redirectUrl = `${environment.adb2cChangePasswordEndpoint}&client_id=${environment.adb2cClientId}&nonce=defaultNonce&redirect_uri=${window.location.origin}/logged&scope=openid&response_type=id_token&prompt=login&lang=${this.locale}`;
				window.location.replace(redirectUrl);
			} else {
				sessionStorage.removeItem('redirect_url');
				sessionStorage.removeItem('search_params');
				this.router.navigate(['/home'], { replaceUrl: true });
			}
		});
	}
}
